module.exports = __webpack_public_path__ + "img/logo-dark.58efa9bd.png";